/* app/js/src/components/live/livePreview.component/livePreview.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 360px;
  display: block;
}
@media only screen and (max-width : 1390px) {
  :host {
    width: 310px;
  }
}
.video-container {
  background-color: #000;
}
.video-container > header {
  background-color: #ef5350;
  color: #ffffff;
  font-size: 0.8em;
  text-align: center;
  line-height: 2em;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.video-container > section {
  background-color: #242f3a;
  color: #ffffff;
  font-size: 0.7em;
  padding: 0.3em 0.4rem 0.2em;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
.video-container > section > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.video-container > div video {
  height: 200px;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.video-container.preview > header {
  background-color: #61b965;
}
footer {
  margin-top: 10px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
/*# sourceMappingURL=livePreview.component.css.map */
